import * as React from "react";

import "./searching-section.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {cascadeFind}    from "@Common/utils/cascade";
import {unique}         from "@Common/utils/collections";

import {SearchError} from "./search-error/search-error";
import {SearchForm}  from "./search-form/search-form";

export const SearchingSection = ({entityId, next}) => cs(

    ["searchedForm", (_, next) => UseState({next})],

    ["searchForm", (_, next) => SearchForm({entityId, next})],

    ({searchForm, searchedForm}) => next({
        searchedForm: searchedForm.value,
        render: ({onSearchResult, loadAddresses}) => cs(
            consumeContext("apis"),
            ["searchError", (_, next) => UseState({
                next,
            })],
            ["searching", (_, next) => UseState({next})],
            ["search", ({searching, searchError, apis}, next) => next(async (form) => {
                searchError.onChange(null);
                searching.onChange(true);
                try {
                    const mapStreetRecordToRequest = (street) => ({
                        streetAddress: street.address,
                        streetZip: street.zip_code,
                    });

                    searchedForm.onChange(form);
                    onSearchResult(null);
                    const result = await apis.next.mailing.searchRadius(form);
                    if (result.alternateAddress) {
                        form.address = result.alternateAddress;
                    }

                    const doNotMailStreets = await apis.next.mailing.getDoNotMailStreets({
                       entityId: form.entityId,
                       streetAddresses: getStreetAddresses(result).map(mapStreetRecordToRequest),
                    });
                    const targetStreet = cascadeFind(result, "streets[*]", (a, {1: streetName}) => !!a.targetAddress && streetName);

                    const loadStreets = unique([
                        ...doNotMailStreets,
                        targetStreet,
                    ].filter(v=>v));

                    if (loadStreets.length) {
                        const addresses = await loadAddresses(loadStreets, {getStreetRecord: (street) => result.streets[street], searchForm: form});
                        if (addresses.result === "failed") {
                            throw {type: "addresses"};
                        }
                    }

                    if (result?.alternateAddress != null) {
                        searchForm.setAddress(result.alternateAddress);
                    }
                    searchedForm.onChange({
                        ...form,
                        address: result?.alternateAddress ?? form.address,
                    });
                    onSearchResult(result);
                } catch (e) {
                    if (e.type === "notFound") {
                        searchError.onChange({
                            type: "notFound",

                            street: form.address,
                            zipCode: form.zip,
                        });
                    } else if (e.type === "alternateStreets") {

                        // searchForm.resetForm(form);

                        searchError.onChange({
                            type: "alternateStreets",
                            street: form.address,
                            zipCode: form.zip,
                            alternateStreets: e.alternateStreets,
                        });
                    } else if (e.type === "addresses") {
                        searchError.onChange({
                            type: "addresses"
                        })
                    } else {
                        alert("Unknown error");
                    }
                } finally {
                    searching.onChange(false);
                }
            })],

            ({search, searchError, searching}) => <>
                {searchForm.render({
                    className: "searching-section-2ed search-form",
                    searching: searching.value,
                    onSearch: search,
                })}

                {searchError.value && (
                    SearchError({
                        error: searchError.value,
                        onChangeStreet: (street) => {
                            searchError.onChange(null);
                            const newForm = searchForm.setAddress(street);
                            search(newForm);
                        },
                    })
                )}
            </>,
        ),
    }),
);

const getStreetAddresses = (result) => {
    return Object.keys(result.streets).map(street => {
        const addressKey = Object.keys(result.streets[street].addresses)[0];
        return result.streets[street].addresses[addressKey];
    });
}